import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import GenricTable from "../../components/GenricTable";
import "./style.scss";
import Filters from "../../components/Filters";
import AreaChartBasic from "../../components/Graphs/AreaChartBasic";
// import PolarAreaChartBasic from "../../components/Graphs/PolarAreaChartBasic";
import PieChart from "../../components/Graphs/PieGraph";
import { useSelector, useDispatch } from "react-redux";
import { getAnalyticsIntent } from "../../services/graphs/actions";
import { HANDLE_ERROR } from "../../services/graphs/actionTypes";
import Loader from "../../components/Loader";
import swal from "sweetalert";
import Footer from "../../components/Footer";
import BarChartRotatedColumns from "../../components/Graphs/BarChartRotatedColumn";
import NoDataAvailable from "../../components/NoDataAvailable";

const Intents = () => {
  const dispatch = useDispatch();

  const { analytics_intent, range, app, isLoading, error } = useSelector(
    ({ graphState, filtersState }) => ({
      analytics_intent: graphState.analytics_intent,
      range: filtersState.range,
      app: filtersState.app,
      isLoading: graphState.isLoading,
      error: graphState.error,
    })
  );

  const [areaOptions, setAreaOptions] = useState({
    chart: {
      id: "basic-bar",
    },
    dataLabels: {
      enabled: false,
    },
    grid: {
      show: false,
    },
    legend: {
      show: true,
    },
    xaxis: {
      labels: { show: true },
    },
    yaxis: {
      opposite: true,
      labels: { show: true },
    },
  });

  const fetch = () => {
    dispatch(
      getAnalyticsIntent({
        platform: app.platform,
        apiKey: app.apiKey,
        fromDate: range.from,
        toDate: range.to,
      })
    );
  };
  useEffect(() => {
    if (error) {
      swal("Error", error.message || "Received Error From DB", "error");
      dispatch({ type: HANDLE_ERROR, payload: null });
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (analytics_intent) {
      setAreaOptions((prev) => ({
        ...prev,
        xaxis: {
          ...prev.xaxis,
          categories: analytics_intent.totalIntentsData.xaxisData,
        },
      }));
    }
  }, [analytics_intent]);

  useEffect(() => {
    fetch();
    // eslint-disable-next-line
  }, []);
  return (
    <div className="intents_container">
      {isLoading && <Loader />}
      <Navbar />
      <Sidebar />

      <div style={{ padding: `0 20px` }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto" }}>
          <h1>Intent</h1>
          <h2>{app.name}</h2>
        </div>
        <Filters fetch={fetch} />
      </div>
      <div className="content">
        <div className="full_section">
          <h2>Incoming Intents</h2>
          {analytics_intent &&
          analytics_intent.incomingIntentsData &&
          analytics_intent.incomingIntentsData.message === "available" ? (
            <PieChart data={analytics_intent.incomingIntentsData.data} />
          ) : (
            <NoDataAvailable title="Incoming Intent" />
          )}
        </div>
        <div className="half_section">
          <h2>Top Intents</h2>
          <GenricTable
            isUtterance={false}
            data={analytics_intent && analytics_intent.topIntentsData}
          />
        </div>
        <div className="half_section">
          <h2>Total Intents</h2>
          {analytics_intent &&
          analytics_intent.totalIntentsData.message === "available" ? (
            <AreaChartBasic
              data={analytics_intent.totalIntentsData.data.seriesData}
              custOptions={areaOptions}
            />
          ) : (
            <NoDataAvailable title="Top Intents" />
          )}
        </div>
        <div className="full_section">
          <h2>Exit Intents</h2>
          {analytics_intent &&
          analytics_intent.exitIntentsData &&
          analytics_intent.exitIntentsData.message === "available" ? (
            <BarChartRotatedColumns
              data={[analytics_intent.exitIntentsData.data[0].series]}
              categories={analytics_intent.exitIntentsData.data[0].categories}
            />
          ) : (
            <NoDataAvailable title="Exit Intent" />
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Intents;
